import {isNil, get} from 'lodash-es'

/**
 * Enhanced version of _.get
 * It's will fallback to defaultValue if the result is undefined or null
 */
const enhancedGet = (obj, path, defaultValue) => {
  const result = get(obj, path)

  if (isNil(result)) {
    return defaultValue
  }

  return result
}

export default enhancedGet
